import React, { Fragment, useState, useEffect, useRef } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Autocomplete from "react-google-autocomplete";
import { parseAddressParts } from "../../../helpers/helpers";
import SummaryItem from "../components/SummaryItem/SummaryItem";

export default function GoogleAddressField(props) {
  let {
    errorText,
    onSelect,
    fieldFormatTransform = (parts) =>
      `${parts.via}${parts.civico ? `, ${parts.civico}` : ""}`,
    placeholder,
    suggestionType,
    restrictions,
    invalidAddressMessage,
    validationSchema,
    ...rest
  } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { setFieldValue } = useFormikContext();

  const [isInvalidAddress, setIsInvalidAddress] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  let type;
  switch (suggestionType) {
    case "regions":
      type = ["(regions)"];
      break;
    case "cities":
      type = ["(cities)"];
      break;
    case "address":
    default:
      type = ["address"];
      break;
  }

  if (!restrictions) {
    restrictions = { country: "IT" };
  }

  const { summaryMode } = rest;
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState("");
  const messageInvalidAddress = invalidAddressMessage
    ? invalidAddressMessage
    : t("cases.errors.address_invalid");

  useEffect(() => {
    setCurrentValue(field.value);
  }, [field.value]);

  const onAddressChange = (e) => {
    setCurrentValue(e.target.value);
    if (e.target.value === "") {
      setValue("");
    }
  };

  const handleSuggestionSelected = (payload) => {
    const parts = parseAddressParts(payload.address_components);
    const isWellformed = (parts) =>
      parts.via && parts.civico && parts.comune && parts.cap && parts.provincia;

    const currentSelected = fieldFormatTransform(parts); //`${parts.via}${parts.civico ? `, ${parts.civico}` : ''}`;
    setCurrentValue(currentSelected);
    setValue(currentSelected);

    if (onSelect) {
      console.log("PARTS " + JSON.stringify(parts));
      console.log(
        "PAYLOAD ADDRESS " + JSON.stringify(payload.address_components)
      );
      if (!isWellformed(parts) && suggestionType === "addresses") {
        setIsInvalidAddress(true);
        setCurrentValue("");
        setValue("");
      } else {
        setIsInvalidAddress(false);
        onSelect(parseAddressParts(payload.address_components), setFieldValue);
      }
    }
  };
  return (
    <Form.Group>
      {!summaryMode ? (
        <>
          {rest.label && (
            <Form.Label className="paragraph-small-fs9" htmlFor={field.name}>
              {rest.label}
            </Form.Label>
          )}
          <Fragment>
            <Form.Control
              type="hidden"
              name={field.name}
              // to deal with the translations for the plaholder [object Object]
              placeholder={
                typeof placeholder === "object"
                  ? t(placeholder.props.i18nKey)
                  : placeholder
              }
              value={field.value}
              onChange={field.onChange}
              className={
                isInvalidAddress || (meta.touched && meta.error)
                  ? "is-invalid"
                  : "nothing"
              }
              id={field.name + "-hidden"}
            />

            <Autocomplete
              language="it"
              className={
                (isInvalidAddress || (meta.touched && meta.error)
                  ? "form-control is-invalid"
                  : "form-control") +
                (isOpen && currentValue
                  ? " pac-target-input google-address-open"
                  : " pac-target-input")
              }
              onPlaceSelected={handleSuggestionSelected}
              placeholder={
                typeof placeholder === "object"
                  ? t(placeholder.props.i18nKey)
                  : placeholder
              }
              types={type}
              value={currentValue}
              onChange={(e) => onAddressChange(e)}
              onFocus={() => setIsOpen(true)}
              onBlur={() => setIsOpen(false)}
              componentRestrictions={restrictions}
              aria-describedby={
                meta.touched && meta.error ? field.name + "-error" : null
              }
              required={isRequired}
              id={field.name}
            />

            {meta.touched && meta.error && (
              <div
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {meta.error}
              </div>
            )}
            {isInvalidAddress && (
              <p
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {messageInvalidAddress}
              </p>
            )}
          </Fragment>
        </>
      ) : (
        <>
          {rest.label && (
            <span className="paragraph-small-fs9">
              {rest.label}
            </span>
          )}
          <SummaryItem value={field.value} error={meta.error} />
        </>
      )}
      {props.subtitle ? (
        <p className="paragraph-small-form">{props.subtitle}</p>
      ) : null}
    </Form.Group>
  );
}
